$(function(){
  setupDatepicker();
  setupEditableCrmRecordName();
  setupCrmAutocomplete();
  setupWithDivisionsCheckbox();
  setupCrmNote();
  //setupOrderForm();
  showCrmLabelsByType();
  setupLicences();
  setupUpdatesPlayersTable();
  setupPipelineFilters();
  setupSalesmanDetailTypeSelect();


  setupHowFoundUsFormEdit();
  setupWhyLeftUsFormEdit();


  
  $('.linkCompanyConfirm').click(function(e) {
    if (!confirm('Opravdu přiřadit?')) {
      e.preventDefault();
      return false;
    }
  });

  $('#frm-crmRecordForm-form-type').change(function() {
      showCrmLabelsByType();


      const companyType = $(this).val();
      const statusOptions = ($(this).data('statusoptions'));   

      $('#frm-crmRecordForm-form-status option').each(function() {
        const option = $(this);
        const optionValue = option.val();

        const statusOption = statusOptions[optionValue].toLowerCase();

        option.show();
        if(!(statusOption.includes(companyType.toLowerCase()) || statusOption.includes('general'))) {
          option.hide();
        }

      });

  });

  
  $('.checkbox-list-toggle').on('click', function() {

    const checkboxListId = $(this).attr('data-target');
    $(`.checkbox-list:not(${checkboxListId})`).hide();

    $(checkboxListId).toggle();
  });

  $('.close-checkbox-list').on('click', function() {
    $('.checkbox-list').hide();
  });
  

  if($('#frm-SuperadminAddCompanyLicencesForm-form').length > 0) {
    setupInstitutionLicencesTable();
  }

  
  if($('#ordersStatsCRM').length > 0) {
    setupOrdersStatsSwitch();
  }

  if($('#frm-PaymentByAdminForm-form-paymentType').length > 0) {
    setupPaymentByAdminPaymentType();
  }

})


function setupPipelineFilters() {

  $('.pipelineFilter:not(.health)').click(function() {

    $('.resetSorting').click();
    
    $('.pipelineFilter').removeClass('active');
    $(this).addClass('active');

    $('.stateInCRM option:contains(' + $(this).attr('data-value') + ')').prop('selected', true);
    $('.stateInCRM').change();

  });

  $('.pipelineFilter.health').on('click', function() {

    $('.resetSorting').click();

    $('.pipelineFilter').removeClass('active');
    $(this).addClass('active');

    $(`#healthLabels .checkbox-list-label input`).prop('checked', false);
    $(`#healthLabels .checkbox-list-label.${$(this).attr('data-value')} input`).click();

  });

}

function showCrmLabelsByType() {
    var allHiden = true;
    $('#crmLabels .label:not(.checkbox-list-label)').each(function() {

      const types = JSON.parse($(this).attr('data-labeltype')); 
      
      if($.inArray($('#frm-crmRecordForm-form-type').val(), types) > -1) {
        $(this).show();
        allHiden = false;
      }else {
        $(this).children().prop('checked', false );
        $(this).hide();
      }
    });

    if(allHiden) {
      $('wGroup').hide();
    } else {
      $('#crmLabelsGroup').show();
    }
}



function setupCrmNote() {

  var form = $('form.crmNewNote');
  form.hide().removeClass('display-none');
  
  $('.btnCreateCrmNote').click(function() {
    form.slideDown();
    $(this).hide();
    $('textarea:first', form).focus();
  });

  $('.btnCancel', form).click(function() {
    if ($('textarea', form).val().length > 0) {
      if (!confirm('Opravdu? Napsaná poznámka nebude uložena!')) {
        return;
      }
    }
    form.slideUp();
    $('.btnCreateCrmNote').show();
  });

  $('.btnEditCrmNote').click(function() {

  });
}

function setupWithDivisionsCheckbox() {
  var withDivisionsDiv = $('#withDivisionsDiv');
  withDivisionsDiv.hide();
  $('.createAccountDiv input[type=checkbox]').change(function() {
    withDivisionsDiv.toggle();
  })

  // check/uncheck hidden checkbox "withDivisions" when the instituion type is changed
  $('select[name=type]').change(function() {
    if (!withDivisionsDiv.is(':visible')) {
      if ($(this).val() == 'school') {
        $('input', withDivisionsDiv).prop('checked', true);
      }
      else {
        $('input', withDivisionsDiv).prop('checked', false);
      }
    }
  });
}

function setupEditableCrmRecordName() {
  $('.editName').click(function() {
    var editableField = $('#'+$(this).attr('data-editableField'));
    if (editableField.length > 0) {
      editableField.prop('readonly', false);    
    }
  
  });
  
}


function setupDatepicker() {
  var datepicker = $('.bootstrapDatepicker');
  if (datepicker.length == 0) return; 

  datepicker.datepicker({
    format: "d. m. yyyy",
    keyboardNavigation: false,
    language: 'cs',
    todayHighlight: true
  })
  .on('changeDate', function(ev) {
    //$(this).click().blur();
    $(this).datepicker('hide');
  });

  $('a.datepicker-setDate', datepicker.parent()).click(function() {
    datepicker.datepicker('update', new Date($(this).attr('data-date')));
  });
}

function setupUpdatesPlayersTable() {


  var isFilterMatching = function(tr, filterName, data) {

    if((data == null || data == '') || $(tr).attr('data-' + filterName) == data) {
      return true;
    } else {
      return false;
    }

  }

  var updatesPlayersTableFiltersApply = function() {
  
    var operationType = $("#playersUpdatesOperations option:selected").val();
    var date = $("#playerUpdatesDate").val();


    $('#playersUpdatesTable tbody tr').each(function() {

      filters = [
        isFilterMatching($(this),'operationType', operationType),
        isFilterMatching($(this), 'updateDate', date),
      ];
        

      if(jQuery.inArray(false, filters) === -1) {
        $(this).removeClass('hidden');
      } else {
        $(this).addClass('hidden')
      }
    });
  }


  $("#playersUpdatesOperations").change(function(){
    updatesPlayersTableFiltersApply();
  });

  $("#playerUpdatesDate").change(function(){
    updatesPlayersTableFiltersApply();
  });



  var resetFilters = function() {
    $('#playerUpdatesDate').val(null);
    $("#playersUpdatesOperations").val('');

    updatesPlayersTableFiltersApply();
  }

  $('.resetFilters').click(function() {
    resetFilters();
  })
  $('.showPlayersUpdatesModal').click(function() {
    resetFilters();
  });

  $('.resetDate').click(function() {

    $('#playerUpdatesDate').val(null);
    updatesPlayersTableFiltersApply();
  })  
}


function setupLicences() {
  
  licencesModalDisabled(true);

  $('.licenceModalOpen').prop('disabled', true);

  $('.divisionsCheckbox').click(function() {

    isChecked = false;
    $('.divisionsCheckbox').each(function() {
      if($(this).prop('checked') == true) {
        isChecked = true;
      }
    });

    $('.licenceModalOpen').prop('disabled', !isChecked);

  });

  $('.checkOtherBoxes').click(function() {
    var isChecked = ($(this).prop('checked'));
    var type = $(this).attr('data-type');

    $('.licenceModalOpen').prop('disabled', !isChecked);
    divisionGroupCheck(isChecked, type);    
  });
  



  $('.licenceModalOpen').click(function() {
    licencesModalDisabled(false)
  });

  $('.licenceModalClose').click(function() {
    licencesModalDisabled(true)
  });




  $('.rowEditBtn').click(function() {
    $rowLicenceValidDate = $('[data-record-id=' + $(this).attr('data-division') + '] .licenceValidInputGroup').attr('data-item-value');
    $('.licenceValidPicker').val($rowLicenceValidDate);

    divisionGroupCheck(false)
  });



  $('input[name=unlimitedLicence]').click(function() {
    $('.licenceValidPicker').prop('disabled', $(this).prop('checked'));
  })


  $('a.datepicker-setDate').click(function() {
    $('.datepicker').val($(this).attr('data-date'));
  });

  $('a.datepicker-setDate-forClass').click(function() {
    $($(this).attr('data-targetDatepicker')).val($(this).attr('data-date'));
  });

  $('a.datepicker-setTwoDates-forClass').click(function() {
    $($(this).attr('data-targetDatepicker1')).val($(this).attr('data-date1'));

    $($(this).attr('data-targetDatepicker2')).val($(this).attr('data-date2'));
  });
}

function licencesModalDisabled(isDisabled) {
  $('.modal-input').prop('disabled', isDisabled);
  $('.unlimitedLicenceCheck input').prop('disabled', isDisabled);
}

function divisionGroupCheck(isChecked, type) {

  if(!isChecked) {
    $('.checkOtherBoxes').prop('checked', isChecked);
  }
  
  $('.divisionsCheckbox').each(function() {
  
    if($(this).hasClass(type) || typeof type == 'undefined') {
      $(this).prop('checked', isChecked);
    }
  
  });

}

function setupInstitutionLicencesTable() {
  
  $('.institutionLicencesTable tbody tr').first().removeClass('hidden');
  
  $('.addTableRow').on('click', function() {
    $('form .institutionLicencesTable tbody tr.hidden').first().removeClass('hidden');  
    
    institutionLicencesTableHideAddRowButtons()
  });  

  $('.addYearTableRow').on('click', function() {

    var lastRow = $('form .institutionLicencesTable tbody tr:not(.hidden)').last();  // posledni viditelny radek

    var startDate = new Date(lastRow.find('.startDate input').val());
    var endDate = new Date(lastRow.find('.endDate input').val());
    var appVersion = lastRow.find('option:selected').val();
    var licenceCount = lastRow.find('.licenceCount input').val();
    


    var nextRow = $('.institutionLicencesTable tbody tr.hidden').first(); 

    nextRow.find('.startDate input').val(modifyDate(startDate, 1));
    nextRow.find('.endDate input').val(modifyDate(endDate, 1));
    nextRow.find('.licenceCount select').val(appVersion);
    nextRow.find('.licenceCount input').val(licenceCount);

    nextRow.removeClass('hidden');
  

    institutionLicencesTableHideAddRowButtons()
  });

  $('.deleteThisTR a').click(function() {
    var tr = $(this).closest('tr');
    $('.startDate input', tr).val('');
    $('.endDate input', tr).val('');
    $('.licenceCount input', tr).val('');
    tr.addClass('hidden');

    institutionLicencesTableHideAddRowButtons();
  });

  institutionLicencesTableHideAddRowButtons()
}

function institutionLicencesTableHideAddRowButtons() {


  if($('.institutionLicencesTable tbody tr.hidden').length == 0) {
    $('.addRowsBox').hide();
  }
  else {
     $('.addRowsBox').show();
  }

}

function modifyDate(date, yearOffset) {
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();

  if (/^\d$/.test(month))  {
    month = '0' + month;
  }

  if (/^\d$/.test(day))  {
    day = '0' + day;
  }

  return ((year + yearOffset) + '-' + month + '-' + day);
}

function setupOrdersStatsSwitch() {

  var expanded = false;

  var showCheckboxes = function() 
  {
    var checkboxes = document.getElementById("checkboxes");
  
    if (!expanded) 
    {
      checkboxes.style.display = "block";
      expanded = true;
    } 
    else 
    {
      checkboxes.style.display = "none";
      expanded = false;
    }
  }

  var setupMultiSelectLabels = function() {

    var setLabelText = function(parameter, text) {
      $('.' + parameter + '-parameter-text').text(text);
    }

    var hash = $(location).attr('hash');
    if(hash == '#tab-jednotlivci') {
      setLabelText('fourth', 'Konverzní poměr kupující/registrovaní');
    } else {
      setLabelText('fourth', 'Průměrná hodnota objednávky');
    }

    if(hash == "#tab-jednotlivci-poukaz") 
    {
      $('#checkboxes').css('height', '80px')
      $('.third-label').hide();
      $('.fourth-label').hide();
    } 
    else 
    {
      $('#checkboxes').css('height', '150px')
      $('.third-label').show();
      $('.fourth-label').show();
    }

  }

  $('a[data-toggle="pill"]').on('click', function() {
    setTimeout(function() {
      setupMultiSelectLabels();
    }, 200);
  });

  $('.multiselect-container').on('click', function() {
    setupMultiSelectLabels();
    showCheckboxes();
  })


  $('.multiselect-checkbox').on('change', function() {

    var isChecked = $(this).prop('checked');
    var parameterName = $(this).attr('data-parameter') + '-parameter';
    
    if(isChecked) {
      $('.' + parameterName).show();
    } else {
      $('.' + parameterName).hide();
    }

    var isFirstColumn = false;
    var isSecondColumn = false;
    $('.multiselect-checkbox').each(function(index, element) {

      if($(element).prop('checked')) {
        parameterName = $(element).attr('data-parameter');

        if(parameterName == 'first' || parameterName == 'third') {
          isFirstColumn = true;
        }

        if(parameterName == 'second' || parameterName == 'fourth') {
          isSecondColumn = true;
        }

      }

    });

    
    if (isFirstColumn) {
      switchCollumns('.orderPriceCell', 1);
      $('.orderCountCell').addClass('borderRightCell');
    }
    
    if(isSecondColumn) {
      switchCollumns('.orderCountCell', 1);
    }

    if(isFirstColumn && isSecondColumn) {
      switchCollumns(null, 2);
    }

  });


  var switchCollumns = function(toHide, colspan) {
    $('.orderCell').removeClass('text-align-center');
    $('.orderPriceCell').show();
    $('.orderCountCell').show();
    $('.orderCountCell').removeClass('borderRightCell');

    if(toHide != null) {
      $(toHide).hide();
      $('.orderCell').addClass('text-align-center');
    }

    $('.orderHeaderCell').attr('colspan', colspan);
  }

}


function setupSalesmanDetailTypeSelect() {

  $('.salesmanStatSelect-select').change(function() {

    switch ($(this, 'option:selected').val()) {
      case 'school':
        $('.salesmanStats.school').removeClass('hidden');
        $('.salesmanStats.company').addClass('hidden');
        break;
      case 'company':
        $('.salesmanStats.company').removeClass('hidden');
        $('.salesmanStats.school').addClass('hidden');
        break;
    }

  })

}


function setupPaymentByAdminPaymentType() {

  var paymentTypeSelect = $('#frm-PaymentByAdminForm-form-paymentType');

  paymentByAdminChangeInputs(paymentTypeSelect.find(':selected').val());

  paymentTypeSelect.on('change', function() {
    paymentByAdminChangeInputs(this.value);
  });

}

function paymentByAdminChangeInputs(selectedValue) {

  const d = new Date();
  const dateNextYear = (d.getFullYear() + 1) + '-' + (d.getMonth() + 1) + "-" + d.getDate();
  
  const unlimitedPrice = $('#paymentByAdminForm').attr('data-unlimitedPrice');
  const halfYearPrice = $('#paymentByAdminForm').attr('data-halfYearPrice');
  const viWithInstitution = $('#paymentByAdminForm').attr('data-viWithInstitution');
  const viSingle = $('#paymentByAdminForm').attr('data-viSingle');
  

  const paymentAmoutInput = $('#frm-PaymentByAdminForm-form-amount');
  const licenceValidUntilInput = $('#frm-PaymentByAdminForm-form-licenceValidUntil');

  $('#licenceValidUntilTr').show();
  $('#amountTr').show();

  paymentAmoutInput.val(0);
  licenceValidUntilInput.val(null);


  if(selectedValue == 'app_unlimited') {
    paymentAmoutInput.val(unlimitedPrice);
    $('#licenceValidUntilTr').hide();
  }
  else if(selectedValue == 'app_halfYear') {
    paymentAmoutInput.val(halfYearPrice);
    $('#licenceValidUntilTr').hide();
  }
  else if(selectedValue == "company") 
  {
    licenceValidUntilInput.val(dateNextYear);
  }
  else if(selectedValue == "free") 
  {
    $('#amountTr').hide();
  }
  else if(selectedValue == 'visuallyImpaired') 
  {
    licenceValidUntilInput.val(dateNextYear);
    paymentAmoutInput.val(viSingle);
  } 
  else if(selectedValue == "visuallyImpairedInstitution") 
  {
    licenceValidUntilInput.val(dateNextYear);
    paymentAmoutInput.val(viWithInstitution);
  }

}



function setupCrmAutocomplete() {
  var autocompleteInput = $('#schoolAccountInput');
  if (autocompleteInput.length == 0) return;

  var availableTags = [
      "ActionScript",
      "AppleScript",
      "Asp",
      "BASIC",
      "C",
      "C++",
      "Clojure",
      "COBOL",
      "ColdFusion",
      "Erlang",
      "Fortran",
      "Groovy",
      "Haskell",
      "Java",
      "JavaScript",
      "Lisp",
      "Perl",
      "PHP",
      "Python",
      "Ruby",
      "Scala",
      "Scheme"
    ];

    var projects = [
      {
        value: "jquery",
        label: "jQuery",
        desc: "the write less, do more, JavaScript library",
        icon: "jquery_32x32.png"
      },
      {
        value: "jquery-ui",
        label: "jQuery UI",
        desc: "the official user interface library for jQuery",
        icon: "jqueryui_32x32.png"
      },
      {
        value: "sizzlejs",
        label: "Sizzle JS",
        desc: "a pure-JavaScript CSS selector engine",
        icon: "sizzlejs_32x32.png"
      }
    ];

  var autocomplete = autocompleteInput.autocomplete({
    source: projects,
    focus: function( event, ui ) {
      autocompleteInput.val( ui.item.label );
      return false;
    }
  });
  //.autocomplete("instance").
  autocomplete._renderItem = function( ul, item ) { 
      return $( "<li>" )
        .append( "<div>" + item.label + "<br>" + item.desc + "</div>" )
        .appendTo( ul );
    };
}


function setupHowFoundUsFormEdit() {

  $('.edit-howFoundUs').on('click', function() {

    $('.howFoundUsForm').show();
    $('.howFoundUsContainer').hide();
    $(this).hide();
    $('.cancelEdit-howFoundUs').css('display', 'inline-block');

  });

  $('.cancelEdit-howFoundUs').on('click', function() {
    $('.howFoundUsForm').hide();
    $('.howFoundUsContainer').show();
    $(this).hide();
    $('.edit-howFoundUs').show();
  });

}

function setupWhyLeftUsFormEdit() {

  $('.edit-whyLeftUs').on('click', function() {

    $('.whyLeftUsForm').show();
    $('.whyLeftUsContainer').hide();
    $(this).hide();
    $('.cancelEdit-whyLeftUs').css('display', 'inline-block');

  });

  $('.cancelEdit-whyLeftUs').on('click', function() {
    $('.whyLeftUsForm').hide();
    $('.whyLeftUsContainer').show();
    $(this).hide();
    $('.edit-whyLeftUs').show();
  });

}
